window.userHelpers = {
    async logout() {

        try {

            const response = await fetch( window.appConfig.routes.userLogout, {
                method: 'post',
                headers: {
                    'X-CSRF-TOKEN': window.appConfig.csrfToken,
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (response.ok) {
                window.globalState.updateAuth(false);
                setTimeout(() => {
                    window.location.replace('/');
                }, 100);
            }

        } catch (error) {
            this.messageError = "Ошибка сети";
        }
    }
}